import React from "react";
import * as Styled from "./Style";
import lifebuoyIcon from "./../../assets/images/icons/ic_lifebuoy.svg";
import scrollTopIcon from "./../../assets/images/icons/ic_box_arrow_up.svg";

const GlobalFooter = () => {
  return (
    <Styled.GlobalFooterStyle>
      <div className="global-footer" id="global-footer">
        <div className="container">
          <div className="row">
            <div className="col-12 footer-items">
              <ul className="footer-menu">
                <li>
                  <a href="/about-us/accessibility">Accessibility</a>
                </li>
                <li>
                  <a href="/about-us/legal-notices">Privacy &amp; Legal</a>
                </li>
                <li>
                  <a href="/about-us/who-we-are/cambridges-ethics">
                    Our Ethics
                  </a>
                </li>
                <li>
                  <a href="/about-us/legal-notices/anti-slavery-and-human-trafficking">
                    Modern Slavery Statement
                  </a>
                </li>
                <li>
                  <a href="/about-us/rights-permissions">
                    Rights &amp; Permissions
                  </a>
                </li>
                <li>
                  <a
                    href="/about-us/feedback"
                    data-ajax-reveal-id="yourFeedback"
                  >
                    Feedback
                  </a>
                </li>
                <li>
                  <a href="/about-us/media">Media</a>
                </li>
                <li>
                  <a href="/sitemap">Sitemap</a>
                </li>
                <li>
                  <a href="/academic/support" title="Lifebuoy">
                    {/* <i className="lifebuoy"></i> */}
                    <img
                      // src={lifebuoyIcon}
                      src={`${lifebuoyIcon}`}
                      className="lifebuoy"
                      alt="Lifebuoy icon"
                    />
                  </a>
                </li>
              </ul>
              <div className="footer-copyright">
                <span>© Cambridge University Press 2021</span>
                <span
                  className="scroll-top"
                  onClick={function () {
                    window.scrollTo(0, 0);
                  }}
                >
                  <img
                    // src={scrollTopIcon}
                    src={`${scrollTopIcon}`}
                    className="lifebuoy"
                  />
                  back to top
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Styled.GlobalFooterStyle>
  );
};

export default GlobalFooter;
